import { fetchClient } from "@babackapp/private-api-client/generated/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const untypedPost = fetchClient.POST as unknown as (
  url: string,
) => Promise<{ data: unknown; error: unknown }>;

export function useTriggerScoresComputation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (shopId: string) => {
      const { data, error } = await untypedPost(
        `/internal/product-recommendations/${shopId}/compute-scores`,
      );
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["product-recommendation-status"],
      });
    },
  });
}
